module.exports = __webpack_public_path__ + "static/img/80W.81e7ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/80W.png
// module id = iaUs
// module chunks = 2